/**
 * @generated SignedSource<<5c4d591f8b1a592d4fe1ada46e6cf979>>
 * @relayHash 32a952014d67b0057adc7b01553cbb8d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 59aea14d53b9d666582c86e38ca652d828e911e876a43cf207a50c947919c769

import type { ConcreteRequest } from 'relay-runtime';
export type ExternalCollaboratorsSpaceInformationMessageQuery$variables = {
  spaceKey?: string | null;
};
export type ExternalCollaboratorsSpaceInformationMessageQuery$data = {
  readonly space: {
    readonly currentUser: {
      readonly isAdmin: boolean;
    };
    readonly externalCollaboratorCount: number;
    readonly id: string | null;
    readonly name: string | null;
  } | null;
};
export type ExternalCollaboratorsSpaceInformationMessageQuery = {
  response: ExternalCollaboratorsSpaceInformationMessageQuery$data;
  variables: ExternalCollaboratorsSpaceInformationMessageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "externalCollaboratorCount"
      },
      {
        "concreteType": "SpaceUserMetadata",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isAdmin"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ExternalCollaboratorsSpaceInformationMessageQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExternalCollaboratorsSpaceInformationMessageQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "32a952014d67b0057adc7b01553cbb8d",
    "id": "59aea14d53b9d666582c86e38ca652d828e911e876a43cf207a50c947919c769",
    "metadata": {},
    "name": "ExternalCollaboratorsSpaceInformationMessageQuery",
    "operationKind": "query",
    "text": "query ExternalCollaboratorsSpaceInformationMessageQuery($spaceKey:String){space(key:$spaceKey){id,name,externalCollaboratorCount,currentUser{isAdmin}}}"
  }
};
})();

(node as any).hash = "930fa48aeb29519bd20c8cdd9958c15b";

export default node;
